
import { Link, useParams } from 'react-router-dom';
import logo from '../assets/pairist.svg';
import { useSession } from '../hooks/useSession';
import { RouteParams } from '../types';
import TeamDropdown from './TeamDropdown';
import UserDropdown from './UserDropdown';

export default function Header() {
  const { userId } = useSession();
  const { teamId } = useParams<RouteParams>();

  return (
    <header className={styles.header}>
      <div className={styles.spacerLeft}>{userId && <TeamDropdown teamId={teamId} />}</div>

      <Link to="/">
        <img className={styles.logo} src={logo} alt="Pairist logo" />
      </Link>

      <div className={styles.spacerRight}>{userId && <UserDropdown />}</div>
    </header>
  );
}

const styles = require('./Header-styles.module.scss');
